export const NAME = 'users'
export const LABEL = 'Użytkownicy'
export const PATH = `/${NAME}/`
export const PATH_PL = `/administracja/uzytkownicy/`
